"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConnectionStatusCommand = exports.setInGameCommand = exports.clearSelectedPiece = exports.selectPiece = exports.closeOverlay = exports.openOverlay = void 0;
const models_1 = require("@creature-chess/models");
const reducer_1 = require("./reducer");
exports.openOverlay = models_1.ClientUi.openOverlayCommand;
exports.closeOverlay = models_1.ClientUi.closeOverlayCommand;
_a = reducer_1.uiSlice.actions, exports.selectPiece = _a.selectPiece, exports.clearSelectedPiece = _a.clearSelectedPiece, exports.setInGameCommand = _a.setInGameCommand, exports.setConnectionStatusCommand = _a.setConnectionStatusCommand;
